"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function usePackage(selector) {
  const { item: packageData, ...rest } = useElement(
    WorkspaceElementType.Package,
    selector,
    (integrationApp) => selector ? integrationApp.package(selector) : void 0
  );
  return { package: packageData, ...rest };
}

export { usePackage };
